import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../public/media/logos/ed002-login.png'
import _imports_1 from '../../../public/media/logos/ed002-regpen.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 cat" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "imgleft",
    alt: "SIREP_logo",
    src: _imports_0
  })
], -1)
const _hoisted_2 = { class: "d-flex flex-center flex-column flex-column-fluid p-0 pb-lg-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  alt: "SIREP_logo",
  src: _imports_1,
  class: "h-100px mb-4"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_router_view)
      ])
    ])
  ], 64))
}